import { DepartmentType } from '../../@types/storeEnums';

export const toOpenCloseDisplay = (hours: IOpenClose, closedText: string = 'Stängt') =>
  hours?.isOpen ? `${hours.openingTime} - ${hours.closingTime}` : closedText;

export const toUiStore = (store: IStore): IUiStore => {
  const openingHours = store.openingHours.sort((a, b) => a.dayOfWeek - b.dayOfWeek);

  return {
    ...store,
    openingHours: openingHours.slice(1).concat([openingHours[0]]),
    reclamation: !!store.departments?.find((d) => d.departmentType === DepartmentType.Reclamation),
    warehouse: store.departments?.find((s) => s.departmentType === DepartmentType.Warehouse),

    locationImageUrl:
      (!!store.location &&
        store.country === 'Sverige' &&
        `https://api.hitta.se/image/v2/0/15/${store.location.latitude}:
      ${store.location.longitude}?width=888&height=269&markers=%7B%22marker%22:1%7D`) ||
      undefined,

    locationUrl:
      store.address &&
      `https://maps.google.com/maps?q=${store.storeName || 'MIO'}+${store.address}`,

    routeDescriptionUrl: `https://www.google.com/maps/dir/?api=1&destination=${store.storeName || 'MIO'}+${store.address}`,
  };
};
